export default {
  namespaced: true,
  state: {
    messages: {}
  },
  getters: {
    getBySlugs: (state, getters) => (hallSlug, roomSlug) => {
      console.log("roomMessagesGetter", hallSlug, roomSlug)

      return _.filter(state.messages, {
        hallSlug: hallSlug,
        roomSlug: roomSlug
      })
    },
    all: state => state.messages
  },
  mutations: {
    init(state, messages) {
      state.messages = messages
    },
    addMessages(state, message) {
      state.messages.push(message)
    },
    removeMessages(state, messages) {
      state.messages = state.messages.filter(stateMessage => {
        return (
          _.findIndex(messages, message => {
            return message.id === stateMessage.id
          }) === -1
        )
      })

      console.log(state.messages)
    }
  },
  actions: {
    convertAll(state, socketIf) {
      state.commit("init", _.orderBy(socketIf.body, "createdAt", "asc"))
    },
    setMessages(state, message) {
      console.log("dispatch")
      state.commit("addMessages", message)
    },
    deleteMessages(state, messages) {
      state.commit("removeMessages", messages)
    }
  }
}
